import {HttpHeaders} from '@angular/common/http';
import {
  AddFavouriteResponse,
  Configuration,
  Contact,
  ContactGroup,
  ContactImage,
  CreateContactGroupResponse,
  CreateContactResponse,
  CreateDepartmentResponse,
  CreateOrganizationResponse,
  Department,
  DirectoryServiceInterface,
  EditContactResponse,
  EndUser,
  EndUserNumber,
  Favourite,
  GetAllEndUserAccessResponse,
  GetAllEndUserNumbersResponse,
  GetContactGroupsResponse,
  GetContactImageResponse,
  GetContactResponse,
  GetContactsResponse,
  GetContactStatusesResponse,
  GetEndUserAccessResponse,
  GetEndUserNumbersResponse,
  GetFavouritesResponse,
  GetOrganizationResponse,
  GetQueueAgentsResponse,
  GetQueuesResponse,
  GetQueueStatusResponse,
  GetServiceNumbersResponse,
  GetServiceProvidersResponse,
  GetSipTerminalsResponse,
  Organization,
  RemoveContactResponse,
  RemoveFavouriteResponse,
  Response,
  SearchOrganizationResponse
} from '@gt-api';
import {EMPTY, Observable, of} from 'rxjs';
import {delay} from 'rxjs/operators';
import {MockData} from '../mock-data';

export class DirectoryServiceStub implements DirectoryServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  private serviceNumbersResponse: GetServiceNumbersResponse = {
    code: 200,
    message: '',
    exception: '',
    serviceNumbers: MockData.serviceNumbers
  };

  private queueAgentsResponse: GetQueueAgentsResponse = {
    code: 200,
    message: '',
    exception: '',
    agents: MockData.agents
  };

  private sipTerminalsResponse: GetSipTerminalsResponse = {
    code: 200,
    message: '',
    exception: '',
    sipTerminals: MockData.sipTerminals
  };

  addFavourite1(organization?: string, login?: string, body?: Favourite): Observable<AddFavouriteResponse> {
    return of({code: 200});
  }

  changeUserPassword1(organization?: string, login?: string, body?: string, extraHttpRequestParams?: any): Observable<Response> {
    return of({code: 200});
  }

  createContact1(organization?: string, login?: string, body?: Contact): Observable<CreateContactResponse> {
    body.id = 99;
    return of({code: 200, contact: body});
  }

  createContactGroup1(organization?: string, login?: string, body?: ContactGroup): Observable<CreateContactGroupResponse> {
    return of({code: 200});
  }

  createDepartment1(organization?: string, body?: Department): Observable<CreateDepartmentResponse> {
    return of({code: 200});
  }

  createOrganization1(organization?: string, body?: Organization): Observable<CreateOrganizationResponse> {
    return of({code: 200, organization: MockData.testOrg});
  }

  deleteOrganization1(organization?: string): Observable<Response> {
    return of({code: 200});
  }

  editContact1(organization?: string, login?: string, body?: Contact): Observable<EditContactResponse> {
    return of({code: 200});
  }

  editContactGroup1(organization?: string, login?: string, body?: ContactGroup): Observable<Response> {
    return of({code: 200});
  }

  editDepartment1(organization?: string, body?: Department): Observable<Response> {
    return EMPTY;
  }

  editEndUserNumber1(organization?: string, login?: string, body?: EndUserNumber): Observable<Response> {
    return of({code: 200});
  }

  editOrganization1(organization?: string, body?: Organization): Observable<Response> {
    return of({code: 200});
  }

  getContact1(organization?: string, login?: string, contactId?: number, fullNumber?: string): Observable<GetContactResponse> {
    return of({code: 200});
  }

  getContactGroups1(organization?: string, login?: string): Observable<GetContactGroupsResponse> {
    return of({code: 200});
  }

  getContactImage1(organization?: string, login?: string, contactId?: number): Observable<GetContactImageResponse> {
    return of({
      code: 200,
      contactImage: {
        base64image: MockData.base64image
      }
    }).pipe(delay(1000));
  }

  getContactStatuses1(organization?: string, login?: string): Observable<GetContactStatusesResponse> {
    return of({code: 200});
  }

  getContacts1(organization?: string, login?: string, departmentId?: number, contactId?: number): Observable<GetContactsResponse> {
    return of({
      code: 200,
      contactList: MockData.getEndUsers()
        .concat(MockData.getContacts())
        .filter(contact => contact.organization === organization)
    });
  }

  getEndUserAccess1(organization?: string, login?: string): Observable<GetEndUserAccessResponse> {
    return of({code: 200, endUserAccessList: MockData.getEndUserAccessData()});
  }

  getEndUserNumbers1(organization?: string, login?: string): Observable<GetEndUserNumbersResponse> {
    return of({code: 200, endUserNumbers: MockData.terminals});
  }

  getFavourites1(organization?: string, login?: string): Observable<GetFavouritesResponse> {
    return of({code: 200, favourites: [{'@type': 'ComponentFavourite', cid: 0, serviceNumber: 1}]});
  }

  getOrganization1(organization?: string): Observable<GetOrganizationResponse> {
    return of({code: 200, organization: {...MockData.testOrg, id: organization}});
  }

  getQueueStatus1(organization?: string, login?: string, serviceNumber?: string, cid?: string): Observable<GetQueueStatusResponse> {
    return of({code: 200});
  }

  getQueues1(organization?: string, login?: string, serviceNumber?: string): Observable<GetQueuesResponse> {
    return of({code: 200, queues: []});
  }

  getServiceProviders1(organization?: string): Observable<GetServiceProvidersResponse> {
    return of({code: 200, providers: []});
  }

  grantAdministratorPermission1(organization?: string, login?: string, extraHttpRequestParams?: any): Observable<Response> {
    return of({code: 200});
  }

  removeContact1(organization?: string, login?: string, body?: Contact): Observable<RemoveContactResponse> {
    return of({code: 200});
  }

  removeContactGroup1(organization?: string, login?: string, body?: ContactGroup): Observable<Response> {
    return of({code: 200});
  }

  removeDepartment1(organization?: string, body?: Department): Observable<Response> {
    return of({code: 200});
  }

  removeFavourite1(organization?: string, login?: string, body?: Favourite): Observable<RemoveFavouriteResponse> {
    return of({code: 200});
  }

  removeComponentFavourite1(
    serviceNumber: string,
    componentId: number,
    organization?: string,
    login?: string,
    extraHttpRequestParams?: any
  ): Observable<RemoveFavouriteResponse> {
    return of({code: 200});
  }

  removeContactFavourite1(
    contactOrganization: string,
    contactId: number,
    organization?: string,
    login?: string,
    extraHttpRequestParams?: any
  ): Observable<RemoveFavouriteResponse> {
    return of({code: 200});
  }

  removeContactGroupWithId1(
    ownerLogin: string,
    id: number,
    organization?: string,
    login?: string,
    extraHttpRequestParams?: any
  ): Observable<Response> {
    return of({code: 200});
  }

  removeContactWithId1(id: number, organization?: string, login?: string, extraHttpRequestParams?: any): Observable<RemoveContactResponse> {
    return of({code: 200});
  }

  removeDepartmentWithId1(id: number, organization?: string, extraHttpRequestParams?: any): Observable<Response> {
    return of({code: 200});
  }

  revokeAdministratorPermission1(organization?: string, login?: string, extraHttpRequestParams?: any): Observable<Response> {
    return of({code: 200});
  }

  searchContacts1(
    organization?: string,
    login?: string,
    nmbr?: string,
    firstName?: string,
    lastName?: string,
    company?: string
  ): Observable<GetContactsResponse> {
    return of({code: 200, contactList: []});
  }

  searchEndUsers1(organization?: string, login?: string, queryString?: string): Observable<GetContactsResponse> {
    return of({code: 200, contactList: []});
  }

  searchOrganization1(
    organization?: string,
    organizationId?: string,
    organizationName?: string,
    entriesPerPage?: number,
    page?: number
  ): Observable<SearchOrganizationResponse> {
    return of({code: 200, organizationList: []});
  }

  sendSipPassword1(fullNumber: string, organization?: string, login?: string): Observable<Response> {
    return of({code: 200});
  }

  sendSipPin1(fullNumber: string, organization?: string, login?: string): Observable<Response> {
    return of({code: 200});
  }

  setContactImage1(organization?: string, login?: string, contactId?: number, body?: ContactImage): Observable<Response> {
    return of({code: 200});
  }

  getQueueAgents1(oname): Observable<GetQueueAgentsResponse> {
    return of(this.queueAgentsResponse);
  }

  getServiceNumbers1(oname): Observable<GetServiceNumbersResponse> {
    return of(this.serviceNumbersResponse);
  }

  getSipTerminals1(organization?: string, login?: string): Observable<GetSipTerminalsResponse> {
    return of(this.sipTerminalsResponse);
  }

  getAllEndUserAccess1(organization?: string, extraHttpRequestParams?: any): Observable<GetAllEndUserAccessResponse> {
    return of({code: 200});
  }

  getAllEndUserNumbers1(organization?: string, extraHttpRequestParams?: any): Observable<GetAllEndUserNumbersResponse> {
    return of({code: 200});
  }

  createEndUser1(endUser?: EndUser, extraHttpRequestParams?: any): Observable<Response> {
    return of({code: 200});
  }

  deleteEndUser1(organization: string, login: string, extraHttpRequestParams?: any): Observable<Response> {
    return of({code: 200});
  }
}
